export default __webpack_public_path__ + "static/img/vogue_scene_animated_0723.9b844ce.jpg";